/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBook} from '@fortawesome/pro-duotone-svg-icons';

const MasterCatalogIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faBook} {...props} />
);

export default MasterCatalogIcon;
